//
//
//
//
//

import { mapState } from 'vuex'
import { showData } from '@/utils/mqtt'
import * as echarts from 'echarts'
import { EleResize } from '@/utils/esresize'


export default {
    props: {
        propValue: {
            type: String,
            require: true,
            default: '',
        },
        element: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            showData,
            data: [],
            optionlineupg: {
                title: {
                    text: this.element.propValue
                },
                tooltip: {},
                legend: {
                    show: this.element.style.legendShow,
                    // data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine']
                },
                toolbox: {
                    show: this.element.style.toolShow,
                    feature: {
                        dataZoom: {
                            yAxisIndex: 'none'
                        },
                        dataView: { readOnly: false },
                        magicType: { type: ['line', 'bar'] },
                        // restore: {},
                        saveAsImage: {},
                        myFull: { // 全屏
                            show: true,
                            title: '全屏',
                            icon: 'path://M432.45,595.444c0,2.177-4.661,6.82-11.305,6.82c-6.475,0-11.306-4.567-11.306-6.82s4.852-6.812,11.306-6.812C427.841,588.632,432.452,593.191,432.45,595.444L432.45,595.444z M421.155,589.876c-3.009,0-5.448,2.495-5.448,5.572s2.439,5.572,5.448,5.572c3.01,0,5.449-2.495,5.449-5.572C426.604,592.371,424.165,589.876,421.155,589.876L421.155,589.876z M421.146,591.891c-1.916,0-3.47,1.589-3.47,3.549c0,1.959,1.554,3.548,3.47,3.548s3.469-1.589,3.469-3.548C424.614,593.479,423.062,591.891,421.146,591.891L421.146,591.891zM421.146,591.891',
                            onclick: (e) => {
                                // 全屏查看
                                let domName = this.$refs.chartmainlineupg
                                if (domName.requestFullScreen) { // HTML W3C 提议
                                    domName.requestFullScreen()
                                } else if (domName.msRequestFullscreen) { // IE11
                                    domName.msRequestFullScreen()
                                } else if (domName.webkitRequestFullScreen) { // Webkit
                                    domName.webkitRequestFullScreen()
                                } else if (domName.mozRequestFullScreen) { // Firefox
                                    domName.mozRequestFullScreen()
                                }
                                // 退出全屏
                                if (domName.requestFullScreen) {
                                    document.exitFullscreen()
                                } else if (domName.msRequestFullScreen) {
                                    document.msExitFullscreen()
                                } else if (domName.webkitRequestFullScreen) {
                                    document.webkitCancelFullScreen()
                                } else if (domName.mozRequestFullScreen) {
                                    document.mozCancelFullScreen()
                                }
                            }
                        }
                    }
                },

                xAxis: [
                    {
                        type: 'category',
                        boundaryGap: false,
                        data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                        name: this.element.style.xname,
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: this.element.style.yname,
                    }
                ],
                series: [
                    {
                        name: 'Email',
                        type: 'line',
                        stack: 'Total',
                        areaStyle: {},
                        emphasis: {
                            focus: 'series'
                        },
                        data: [120, 132, 101, 134, 90, 230, 210]
                    },
                    {
                        name: 'Union Ads',
                        type: 'line',
                        stack: 'Total',
                        areaStyle: {},
                        emphasis: {
                            focus: 'series'
                        },
                        data: [220, 182, 191, 234, 290, 330, 310]
                    },
                    {
                        name: 'Video Ads',
                        type: 'line',
                        stack: 'Total',
                        areaStyle: {},
                        emphasis: {
                            focus: 'series'
                        },
                        data: [150, 232, 201, 154, 190, 330, 410]
                    },
                    {
                        name: 'Direct',
                        type: 'line',
                        stack: 'Total',
                        areaStyle: {},
                        emphasis: {
                            focus: 'series'
                        },
                        data: [320, 332, 301, 334, 390, 330, 320]
                    },
                    {
                        name: 'Search Engine',
                        type: 'line',
                        stack: 'Total',
                        label: {
                            show: true,
                            position: 'top'
                        },
                        areaStyle: {},
                        emphasis: {
                            focus: 'series'
                        },
                        data: [820, 932, 901, 934, 1290, 1330, 1320]
                    }
                ]
            },
            chartmainlineupg: null,
        }
    },
    computed: {
        ...mapState([
            'editMode',
        ]),
    },
    mounted() {
        this.drawLlineupg()
        window.refreshLineupg = this.refreshLineupg
    },
    craeted() {

    },
    methods: {
        drawLlineupg() {
            // 基于准本好的DOM，初始化echarts实例
            this.chartmainlineupg = echarts.init(this.$refs.chartmainlineupg, this.element.style.mode ? 'dark' : 'light')
            // 绘制图表
            this.chartmainlineupg.setOption(this.optionlineupg)
            // 自适应
            let self = this
            var listener = function () {
                self.chartmainlineupg.resize()
            }
            EleResize.on(this.$refs.chartmainlineupg, listener)
        },
        refreshLineupg() {
            if (this.editMode == 'show') {
                if (this.showData.hasOwnProperty(this.element.events.subscribeTopic)) {
                    var itemsArray = []
                    let x = this.showData[this.element.events.subscribeTopic].x
                    let data = this.showData[this.element.events.subscribeTopic].data
                    // console.log(this.showData[this.element.events.subscribeTopic].data);
                    // console.log(1111111);
                    // this.list = this.showData[this.element.events.subscribeTopic].data.map(item =>{
                    //                 return item.data
                    //             })

                    for (let index = 0; index < data.length; index++) {
                        const element = data[index];
                        // if (index == data.length-1) {
                        //     console.log("label"+index);
                        //     var item = {
                        //         name: element.name,
                        //         type: 'line',
                        //         stack: 'Total',
                        //         label: {
                        //             show: true,
                        //             position: 'top'
                        //         },
                        //         areaStyle: {},
                        //         emphasis: {
                        //             focus: 'series'
                        //         },
                        //         data: element.data
                        //     }
                        //     itemsArray.push(item)
                        // } 
                        // else {
                        //     console.log("labelss"+index);
                            var item = {
                                name: element.name,
                                type: 'line',
                                stack: 'Total',
                                areaStyle: {},
                                emphasis: {
                                    focus: 'series'
                                },
                                data: element.data
                            }
                            itemsArray.push(item)
                        // }
                    }

                    this.chartmainlineupg.setOption({
                        xAxis: {
                            type: 'category',
                            data: x,
                        },
                        series: itemsArray,
                    });
                }
            }
        }
    },
}
